import { Link } from 'react-router-dom';

import styled from 'styled-components';

function CardBox(props) {
    return (
        <Card>
            <ArticleInfoSection>
                <ImageSection>
                    <CoverImage src={props.data['COVER_IMAGE']} />
                </ImageSection>
                <TextSection>
                    <Title>{props.data['TITLE']}</Title>
                    <SampleText>{props.data['CONTENT']}</SampleText>
                </TextSection>
                <InfoSection>
                    <Info>
                        게시일
                        <br />
                        {props.data['RELEASE_DATE']}
                    </Info>
                    <Info>
                        조회수
                        <br />
                        {props.data['VIEWS']}
                    </Info>
                </InfoSection>
            </ArticleInfoSection>
                <ButtonSection>
                    <Link to={'/edit/' + props.data['ARTICLE_ID']}>수정하기</Link>
                    <Link
                        to="#"
                        onClick={() => {
                            props.delete_article(props.data['ARTICLE_ID'], props.idx);
                        }}
                    >
                        삭제하기
                    </Link>
                </ButtonSection>
        </Card>
    );
}

export default CardBox;

const Card = styled.article`
    width: 100%;
    height: 130px;
    background-color: #f2f2f2;

    border-radius: 10px;
    overflow: hidden;

    font-size: 16px;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
`;

const ArticleInfoSection = styled.section`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    min-width: 806px;

    cursor: default;
`;

const ImageSection = styled.section`
    width: 240px;

    flex-shrink: 0;
`;

const CoverImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const TextSection = styled.section`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    flex-shrink: 1;
    gap: 12px;

    width: 500px;
    min-width: 300px;

    margin-left: 18px;
    padding: 16px 0px 10px;
`;

const Title = styled.h2`
    font-size: 20px;
    line-height: 24px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const SampleText = styled.p`
    font-size: 16px;
    line-height: 20px;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
`;

const InfoSection = styled.section`
    padding: 46px 0px;
    margin-left: 48px;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: 59px;
`;

const Info = styled.p`
    line-height: 20px;
`;

const ButtonSection = styled.section`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: 26px;

    padding: 55px 0px;
    margin-right: 40px;
    margin-left: 48px;
`;
